import bgTableSale from "../../assets/predios-centro.png";
export default function GetableSale() {
  return (
    <>
      <meta charSet="utf-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="theme-color" content="#000000" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      <meta name="twitter:card" content="summary" />
      <link
        rel="canonical"
        href="https://vc.parceirosbari.com.br/vendadecarteira"
      />
      <title />
      {/* Reset Browser Styles */}
      <style
        type="text/css"
        rel="stylesheet"
        dangerouslySetInnerHTML={{
          __html:
            "\n      html, body, div, span, applet, object, iframe,\n      h1, h2, h3, h4, h5, h6, p, blockquote, pre,\n      a, abbr, acronym, address, big, cite, code,\n      del, dfn, em, img, ins, kbd, q, s, samp,\n      small, strike, strong, sub, sup, tt, var,\n      b, u, i, center,\n      dl, dt, dd, ol, ul, li,\n      fieldset, form, label, legend,\n      table, caption, tbody, tfoot, thead, tr, th, td,\n      article, aside, canvas, details, embed,\n      figure, figcaption, footer, header, hgroup,\n      menu, nav, output, ruby, section, summary,\n      time, mark, audio, video {\n        margin: 0;\n        padding: 0;\n        border: 0;\n        font-size: 100%;\n        font: inherit;\n        vertical-align: baseline;\n      }\n\n      article, aside, details, figcaption, figure,\n      footer, header, hgroup, menu, nav, section {\n        display: block;\n      }\n\n      body {\n        line-height: 1;\n      }\n\n      img {\n        vertical-align: middle;\n      }\n\n      ol, ul {\n        list-style: none;\n      }\n\n      blockquote, q {\n        quotes: none;\n      }\n\n      blockquote:before, blockquote:after,\n      q:before, q:after {\n        content: '';\n        content: none;\n      }\n\n      table {\n        border-collapse: collapse;\n        border-spacing: 0;\n      }\n\n      b, strong {\n        font-weight: bold;\n      }\n\n      i, em {\n        font-style: italic;\n      }\n    ",
        }}
      />
      {/* Bricks Main Styles */}
      <style
        type="text/css"
        rel="stylesheet"
        dangerouslySetInnerHTML={{
          __html:
            '\n      * {\n        -webkit-box-sizing: border-box;\n        -moz-box-sizing: border-box;\n        box-sizing: border-box;\n      }\n\n      body {\n        background-color: #FFFFFF;\n        color: #333333;\n        font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;\n        font-size: 16px;\n        line-height: 1.42857;\n      }\n\n      h1, h2, h3, h4, h5, h6 {\n        font-family: inherit;\n        font-weight: 500;\n        line-height: 1.2;\n        color: inherit;\n      }\n\n      h1 { font-size: 41px; }\n      h2 { font-size: 34px; }\n      h3 { font-size: 28px; }\n      h4 { font-size: 20px; }\n      h5 { font-size: 16px; }\n      h6 { font-size: 14px; }\n\n      .bricks--page {\n        width: 100%;\n      }\n\n      .bricks--section {\n        width: 100%;\n      }\n\n      .bricks--section > div {\n        margin-left: auto;\n        margin-right: auto;\n      }\n\n      .bricks--row {\n        display: flex;\n        flex-flow: column nowrap;\n      }\n\n      .bricks--column > div {\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n      }\n\n      .bricks--component-box {\n        display: flex;\n        flex-flow: column nowrap;\n        width: 100%;\n      }\n\n      @media screen and (min-width: 768px) {\n        .bricks--row {\n          flex-flow: row nowrap;\n        }\n      }\n    ',
        }}
      />
      {/* Bricks Component Form Styles */}
      <style
        type="text/css"
        rel="stylesheet"
        dangerouslySetInnerHTML={{
          __html:
            '\n      .bricks-form {\n        height: auto;\n        width: 100%;\n      }\n\n      .bricks-form__fieldset {\n        display: flex;\n        flex-flow: row wrap;\n        margin-left: -5px;\n        margin-right: -5px;\n      }\n\n      .bricks-form__field {\n        display: flex;\n        width: 100%;\n        flex-grow: 1;\n        flex-direction: column;\n      }\n\n      .bricks-form__label {\n        position: relative !important;\n        display: inline-block;\n        max-width: 100%;\n        margin-bottom: 0.4em;\n        line-height: 1.25;\n        vertical-align: middle;\n      }\n\n      .bricks-form__input {\n        display: block;\n        width: 100%;\n        padding: 0 0.5em;\n        line-height: 1.42857;\n      }\n\n      .bricks-form__input.error {\n        border: 1px solid red !important;\n      }\n\n      .bricks-form__field__option .bricks-form__label {\n        padding-left: 1.33em;\n        margin-bottom: 0.2em;\n      }\n\n      .bricks-form__field__option .bricks-form__label input[type="checkbox"],\n      .bricks-form__field__option .bricks-form__label input[type="radio"] {\n        margin: 0px 0px 0px -1.33em;\n      }\n\n      .bricks-form__submit {\n        position: relative;\n      }\n    ',
        }}
      />
      <link
        href="https://fonts.googleapis.com/css?family=Droid+Sans|Droid+Serif|Lato|Lobster|Open+Sans|Oswald|PT+Sans|Raleway|Source+Sans+Pro|Ubuntu|Roboto"
        rel="stylesheet"
      />
      <link
        href="https://cdnjs.cloudflare.com/ajax/libs/select2/3.5.2/select2.min.css"
        rel="stylesheet"
      />
      {/* Bricks Static Shared Styles */}
      <style
        type="text/css"
        rel="stylesheet"
        dangerouslySetInnerHTML={{
          __html:
            "\n   .bricks--component-video div {\n    position: relative;\n    height: 0;\n    padding-bottom: 56.25%;\n    line-height: 0;\n    box-sizing: border-box;\n  }\n\n   .bricks--component-video div iframe {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n  }\n",
        }}
      />
      {/* Bricks Static Text Styles */}
      <style
        type="text/css"
        rel="stylesheet"
        dangerouslySetInnerHTML={{
          __html:
            "\n\n   .bricks--component-text {\n    color: #333;\n    line-height: 1.42;\n    overflow: hidden;\n    word-wrap: break-word;\n  }\n\n   .bricks--component-text a {\n    color: #31a2ff;\n    text-decoration: none;\n  }\n\n   .bricks--component-text sub, sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n   .bricks--component-text sub {\n    bottom: -0.25em;\n  }\n\n   .bricks--component-text sup {\n    top: -0.5em;\n  }\n\n   .bricks--component-text ol, \n   .bricks--component-text ul {\n    padding-left: 1.5em;\n  }\n\n   .bricks--component-text ol > li,\n   .bricks--component-text ul > li {\n    list-style-type: none;\n  }\n\n   .bricks--component-text ul > li::before {\n    content: '\\2022';\n  }\n\n   .bricks--component-text li::before {\n    display: inline-block;\n    white-space: nowrap;\n    width: 1.2em;\n  }\n\n   .bricks--component-text li:not(.ql-direction-rtl)::before {\n    margin-left: -1.5em;\n    margin-right: 0.3em;\n    text-align: right;\n  }\n\n   .bricks--component-text li.ql-direction-rtl::before {\n    margin-left: 0.3em;\n    margin-right: -1.5em;\n  }\n\n   .bricks--component-text ol li:not(.ql-direction-rtl),\n   .bricks--component-text ul li:not(.ql-direction-rtl) {\n    padding-left: 1.5em;\n  }\n\n   .bricks--component-text ol li.ql-direction-rtl,\n   .bricks--component-text ul li.ql-direction-rtl {\n    padding-right: 1.5em;\n  }\n\n   .bricks--component-text ol li {\n    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n    counter-increment: list-0;\n  }\n\n   .bricks--component-text ol li:before {\n    content: counter(list-0, decimal) '. ';\n  }\n\n   .bricks--component-text ol li.ql-indent-1 {\n    counter-increment: list-1;\n  }\n\n   .bricks--component-text ol li.ql-indent-1:before {\n    content: counter(list-1, lower-alpha) '. ';\n  }\n\n   .bricks--component-text ol li.ql-indent-1 {\n    counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  }\n\n   .bricks--component-text ol li.ql-indent-2 {\n    counter-increment: list-2;\n  }\n\n   .bricks--component-text ol li.ql-indent-2:before {\n    content: counter(list-2, lower-roman) '. ';\n  }\n\n   .bricks--component-text ol li.ql-indent-2 {\n    counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  }\n\n   .bricks--component-text ol li.ql-indent-3 {\n    counter-increment: list-3;\n  }\n\n   .bricks--component-text ol li.ql-indent-3:before {\n    content: counter(list-3, decimal) '. ';\n  }\n\n   .bricks--component-text ol li.ql-indent-3 {\n    counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;\n  }\n\n   .bricks--component-text ol li.ql-indent-4 {\n    counter-increment: list-4;\n  }\n\n   .bricks--component-text ol li.ql-indent-4:before {\n    content: counter(list-4, lower-alpha) '. ';\n  }\n\n   .bricks--component-text ol li.ql-indent-4 {\n    counter-reset: list-5 list-6 list-7 list-8 list-9;\n  }\n\n   .bricks--component-text ol li.ql-indent-5 {\n    counter-increment: list-5;\n  }\n\n   .bricks--component-text ol li.ql-indent-5:before {\n    content: counter(list-5, lower-roman) '. ';\n  }\n\n   .bricks--component-text ol li.ql-indent-5 {\n    counter-reset: list-6 list-7 list-8 list-9;\n  }\n\n   .bricks--component-text ol li.ql-indent-6 {\n    counter-increment: list-6;\n  }\n\n   .bricks--component-text ol li.ql-indent-6:before {\n    content: counter(list-6, decimal) '. ';\n  }\n\n   .bricks--component-text ol li.ql-indent-6 {\n    counter-reset: list-7 list-8 list-9;\n  }\n\n   .bricks--component-text ol li.ql-indent-7 {\n    counter-increment: list-7;\n  }\n\n   .bricks--component-text ol li.ql-indent-7:before {\n    content: counter(list-7, lower-alpha) '. ';\n  }\n\n   .bricks--component-text ol li.ql-indent-7 {\n    counter-reset: list-8 list-9;\n  }\n\n   .bricks--component-text ol li.ql-indent-8 {\n    counter-increment: list-8;\n  }\n\n   .bricks--component-text ol li.ql-indent-8:before {\n    content: counter(list-8, lower-roman) '. ';\n  }\n\n   .bricks--component-text ol li.ql-indent-8 {\n    counter-reset: list-9;\n  }\n\n   .bricks--component-text ol li.ql-indent-9 {\n    counter-increment: list-9;\n  }\n\n   .bricks--component-text ol li.ql-indent-9:before {\n    content: counter(list-9, decimal) '. ';\n  }\n\n   .bricks--component-text .ql-indent-1:not(.ql-direction-rtl) {\n    padding-left: 3em;\n  }\n\n   .bricks--component-text li.ql-indent-1:not(.ql-direction-rtl) {\n    padding-left: 4.5em;\n  }\n\n   .bricks--component-text .ql-indent-1.ql-direction-rtl.ql-align-right {\n    padding-right: 3em;\n  }\n\n   .bricks--component-text li.ql-indent-1.ql-direction-rtl.ql-align-right {\n    padding-right: 4.5em;\n  }\n\n   .bricks--component-text .ql-indent-2:not(.ql-direction-rtl) {\n    padding-left: 6em;\n  }\n\n   .bricks--component-text li.ql-indent-2:not(.ql-direction-rtl) {\n    padding-left: 7.5em;\n  }\n\n   .bricks--component-text .ql-indent-2.ql-direction-rtl.ql-align-right {\n    padding-right: 6em;\n  }\n\n   .bricks--component-text li.ql-indent-2.ql-direction-rtl.ql-align-right {\n    padding-right: 7.5em;\n  }\n\n   .bricks--component-text .ql-indent-3:not(.ql-direction-rtl) {\n    padding-left: 9em;\n  }\n\n   .bricks--component-text li.ql-indent-3:not(.ql-direction-rtl) {\n    padding-left: 10.5em;\n  }\n\n   .bricks--component-text .ql-indent-3.ql-direction-rtl.ql-align-right {\n    padding-right: 9em;\n  }\n\n   .bricks--component-text li.ql-indent-3.ql-direction-rtl.ql-align-right {\n    padding-right: 10.5em;\n  }\n\n   .bricks--component-text .ql-indent-4:not(.ql-direction-rtl) {\n    padding-left: 12em;\n  }\n\n   .bricks--component-text li.ql-indent-4:not(.ql-direction-rtl) {\n    padding-left: 13.5em;\n  }\n\n   .bricks--component-text .ql-indent-4.ql-direction-rtl.ql-align-right {\n    padding-right: 12em;\n  }\n\n   .bricks--component-text li.ql-indent-4.ql-direction-rtl.ql-align-right {\n    padding-right: 13.5em;\n  }\n\n   .bricks--component-text .ql-indent-5:not(.ql-direction-rtl) {\n    padding-left: 15em;\n  }\n\n   .bricks--component-text li.ql-indent-5:not(.ql-direction-rtl) {\n    padding-left: 16.5em;\n  }\n\n   .bricks--component-text .ql-indent-5.ql-direction-rtl.ql-align-right {\n    padding-right: 15em;\n  }\n\n   .bricks--component-text li.ql-indent-5.ql-direction-rtl.ql-align-right {\n    padding-right: 16.5em;\n  }\n\n   .bricks--component-text .ql-indent-6:not(.ql-direction-rtl) {\n    padding-left: 18em;\n  }\n\n   .bricks--component-text li.ql-indent-6:not(.ql-direction-rtl) {\n    padding-left: 19.5em;\n  }\n\n   .bricks--component-text .ql-indent-6.ql-direction-rtl.ql-align-right {\n    padding-right: 18em;\n  }\n\n   .bricks--component-text li.ql-indent-6.ql-direction-rtl.ql-align-right {\n    padding-right: 19.5em;\n  }\n\n   .bricks--component-text .ql-indent-7:not(.ql-direction-rtl) {\n    padding-left: 21em;\n  }\n\n   .bricks--component-text li.ql-indent-7:not(.ql-direction-rtl) {\n    padding-left: 22.5em;\n  }\n\n   .bricks--component-text .ql-indent-7.ql-direction-rtl.ql-align-right {\n    padding-right: 21em;\n  }\n\n   .bricks--component-text li.ql-indent-7.ql-direction-rtl.ql-align-right {\n    padding-right: 22.5em;\n  }\n\n   .bricks--component-text .ql-indent-8:not(.ql-direction-rtl) {\n    padding-left: 24em;\n  }\n\n   .bricks--component-text li.ql-indent-8:not(.ql-direction-rtl) {\n    padding-left: 25.5em;\n  }\n\n   .bricks--component-text .ql-indent-8.ql-direction-rtl.ql-align-right {\n    padding-right: 24em;\n  }\n\n   .bricks--component-text li.ql-indent-8.ql-direction-rtl.ql-align-right {\n    padding-right: 25.5em;\n  }\n\n   .bricks--component-text .ql-indent-9:not(.ql-direction-rtl) {\n    padding-left: 27em;\n  }\n\n   .bricks--component-text li.ql-indent-9:not(.ql-direction-rtl) {\n    padding-left: 28.5em;\n  }\n\n   .bricks--component-text .ql-indent-9.ql-direction-rtl.ql-align-right {\n    padding-right: 27em;\n  }\n\n   .bricks--component-text li.ql-indent-9.ql-direction-rtl.ql-align-right {\n    padding-right: 28.5em;\n  }\n\n   .bricks--component-text .ql-direction-rtl {\n    direction: rtl;\n    text-align: inherit;\n  }\n  \n",
        }}
      />
      {/* Defines page width style to row components */}
      <style
        dangerouslySetInnerHTML={{
          __html:
            "\n      .bricks--section > div {\n        max-width: 960px;\n      }\n    ",
        }}
      />
      <div className="bricks--container">
        <div className="bricks--page">
          <style
            type="text/css"
            rel="stylesheet"
            dangerouslySetInnerHTML={{
              __html:
                "\n  \n    #rd-section-jsdbj8lx {\n      \n            background-image: url(https://strapi.bancobari.com.br/uploads/Diferenca_entre_financiamento_e_refinanciamento_de_imovel_3700730f4f.png), linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 100%);\n            background-position-x: 100%;\n            background-position-y: 100%;\n            background-repeat: no-repeat;\n            background-size: cover;\n            background-attachment: fixed;\n          \n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n    }\n\n    #rd-section-jsdbj8lx > div:not(.bricks--row) {\n      min-height: 0px;\n    }\n  \n",
            }}
          />
          <section
            id="rd-section-jsdbj8lx"
            className="bricks--section rd-section"
          >
            <style
              type="text/css"
              rel="stylesheet"
              dangerouslySetInnerHTML={{
                __html:
                  "\n  \n    #rd-row-jsdbj8ly {\n      min-height: 472px;\n    }\n\n    #rd-row-jsdbj8ly .bricks--column > div {\n      min-height: 472px;\n    }\n\n    @media screen and (max-width: 767px) {\n      #rd-row-jsdbj8ly.bricks--row.rd-row {\n        min-height: auto;\n      }\n    }\n  \n",
              }}
            />
            <div id="rd-row-jsdbj8ly" className="bricks--row rd-row">
              <style
                type="text/css"
                rel="stylesheet"
                dangerouslySetInnerHTML={{
                  __html:
                    "\n  \n    #rd-column-jsdbl0x8 {\n      flex: 7 0 0;\n    }\n\n    #rd-column-jsdbl0x8 > div {\n      \n          background-color: transparent;\n        \n      justify-content: center;\n      padding-top: 0px;\n      padding-right: 30px;\n      padding-bottom: 0px;\n      padding-left: 30px;\n    }\n    @media screen and (max-width: 767px) {\n      #rd-column-jsdbl0x8 > div {\n        min-height: auto !important;\n      }\n    }\n  \n",
                }}
              />
              <div id="rd-column-jsdbl0x8" className="bricks--column rd-column">
                <div>
                  <style
                    type="text/css"
                    rel="stylesheet"
                    dangerouslySetInnerHTML={{
                      __html:
                        "\n  \n    #rd-image-kqmt74c2 {\n      margin-top: -116px;\n      margin-bottom: 10px;\n      align-self: flex-start;\n      max-width: 199px;\n    }\n\n    #rd-image-kqmt74c2 a,\n    #rd-image-kqmt74c2 img {\n      width: 199px;\n      max-width: 100%;\n      height: auto;\n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n    }\n    @media screen and (max-width: 767px) {\n      #rd-image-kqmt74c2 {\n        align-self: center;\n      }\n    }\n  \n",
                    }}
                  />
                  <div
                    id="rd-image-kqmt74c2"
                    className="bricks--component bricks--component-image rd-image"
                  >
                    <img
                      src="https://d335luupugsy2.cloudfront.net/cms/files/13591/1625258792/$flrd0187xrj"
                      alt=""
                    />
                  </div>
                  <style
                    type="text/css"
                    rel="stylesheet"
                    dangerouslySetInnerHTML={{
                      __html:
                        "\n  \n    #rd-text-jsc3nryj {\n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n      min-height: auto0px;\n      max-width: 500px;\n      margin-top: 88px;\n      margin-bottom: 30px;\n      align-self: center;\n      width: 100%;\n      word-break: break-word;\n    }\n  \n",
                    }}
                  />
                  <div
                    id="rd-text-jsc3nryj"
                    className="bricks--component bricks--component-text rd-text"
                  >
                    <p style={{ lineHeight: 1 }}>
                      <br />
                    </p>
                    <h1 style={{ lineHeight: 1 }}>
                      <strong
                        style={{
                          backgroundColor: "transparent",
                          fontFamily: "Arial, Helvetica, sans-serif",
                          color: "rgb(255, 255, 255)",
                          fontSize: 28,
                        }}
                      >
                        VENDA SUA CARTEIRA{" "}
                      </strong>
                    </h1>
                    <h1 style={{ lineHeight: 1 }}>
                      <strong
                        style={{
                          backgroundColor: "transparent",
                          fontFamily: "Arial, Helvetica, sans-serif",
                          color: "rgb(255, 255, 255)",
                          fontSize: 28,
                        }}
                      >
                        IMOBILIÁRIA PARA O{" "}
                      </strong>
                    </h1>
                    <h1 style={{ lineHeight: 1 }}>
                      <strong
                        style={{
                          backgroundColor: "transparent",
                          fontFamily: "Arial, Helvetica, sans-serif",
                          color: "rgb(255, 255, 255)",
                          fontSize: 28,
                        }}
                      >
                        BANCO BARI E RECEBA EM
                      </strong>
                    </h1>
                    <h1 style={{ lineHeight: 1 }}>
                      <strong
                        style={{
                          backgroundColor: "rgb(0, 144, 255)",
                          fontFamily: "Arial, Helvetica, sans-serif",
                          color: "rgb(255, 255, 255)",
                          fontSize: 28,
                        }}
                      >
                        ATÉ 30 DIAS CORRIDOS.
                      </strong>
                    </h1>
                    <p style={{ lineHeight: 1 }}>
                      <br />
                    </p>
                    <p style={{ lineHeight: 1 }}>
                      <br />
                    </p>
                    <p style={{ lineHeight: 4 }}>
                      <br />
                    </p>

                    <p
                      style={{
                        fontFamily: "Arial, Helvetica, sans-serif",
                        color: "rgb(255, 255, 255)",
                        backgroundColor: "#00000047",
                        fontSize: 21,
                        width: "fit-content",
                      }}
                    >
                      Entre em contato:
                    </p>
                    <style
                      type="text/css"
                      rel="stylesheet"
                      dangerouslySetInnerHTML={{
                        __html:
                          "\n  \n     a#rd-button-joq3m2w0 {\n   \n   display: flex;\n      flex-direction: column;\n    }\n\n    #rd-button-joq3m2w0 {\n      -ms-flex-align: center;\n      -ms-flex-direction: column;\n      -ms-flex-pack: center;\n      align-self: center;\n      background-color:rgb(0, 144, 255);\n      border-bottom-style: none;\n a:hover{background-color:#000}     border-color: transparent;\n      border-left-style: none;\n      border-radius: 10px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 0px;\n      color: #FFFFFF;\n      cursor: pointer;\n      font-family: Arial, Helvetica, sans-serif;\n      font-size: 18px;\n      font-style: normal;\n      font-weight: bold;\n      height: 55px;\n      justify-content: center;\n      line-height: 1.42857;\n      margin-bottom: 20px;\n      margin-top: 10px;\n      max-width: 200px;\n      text-align: center;\n      text-decoration: none;\n      width: 100%;\n      padding-right: 10px;\n      padding-left: 10px;\n    }\n    @media screen and (max-width: 767px) {\n      #rd-button-joq3m2w0 {\n        height: auto;\n        padding-top: 0.66em;\n        padding-bottom: 0.66em;\n      }\n    }\n  \n ",
                      }}
                    />
                    <div className="bricks-form__submit">
                      <a 
                        href="https://api.whatsapp.com/send/?phone=551199712-0472&text=Olá! 
Estou entrando em contato sobre venda de recebíveis imobiliários.&type=phone_number&app_absent=0"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {" "}
                        <button
                          style={{ marginRight: "20px" }}
                          className="bricks--component bricks--component-button rd-button"
                          id="rd-button-joq3m2w0"
                        >
                          WhatsApp
                        </button>
                      </a>
                      <a href="mailto:comercial@barisecuritizadora.com.br">
                        <button
                          className="bricks--component bricks--component-button rd-button"
                          id="rd-button-joq3m2w0"
                        >
                          Email
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <style
                type="text/css"
                rel="stylesheet"
                dangerouslySetInnerHTML={{
                  __html:
                    "\n  \n    #rd-column-jsdbj8lz {\n      flex: 5 0 0;\n    }\n\n    #rd-column-jsdbj8lz > div {\n      \n          background-color: #efefef;\n        \n      justify-content: flex-start;\n      padding-top: 0px;\n      padding-right: 30px;\n      padding-bottom: 0px;\n      padding-left: 30px;\n    }\n    @media screen and (max-width: 767px) {\n      #rd-column-jsdbj8lz > div {\n        min-height: auto !important;\n      }\n    }\n  \n",
                }}
              />
              {/* <div id="rd-column-jsdbj8lz" className="bricks--column rd-column">
              <div>
                <style
                  type="text/css"
                  rel="stylesheet"
                  dangerouslySetInnerHTML={{
                    __html:
                      "\n  \n    #rd-text-jsdbn3pn {\n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n      min-height: auto-25px;\n      max-width: 330px;\n      margin-top: 20px;\n      margin-bottom: 10px;\n      align-self: center;\n      width: 100%;\n      word-break: break-word;\n    }\n  \n"
                  }}
                />
                <div
                  id="rd-text-jsdbn3pn"
                  className="bricks--component bricks--component-text rd-text"
                >
                  <p style={{ textAlign: "center" }}>
                    <strong
                      style={{ fontSize: 18, fontFamily: "Lato, sans-serif" }}
                    >
                      Preencha seus dados abaixo.{" "}
                    </strong>
                  </p>
                  <p style={{ textAlign: "center" }}>
                    <strong
                      style={{ fontSize: 18, fontFamily: "Lato, sans-serif" }}
                    >
                      Entraremos em contato.
                    </strong>
                  </p>
                </div>
                <style
                  type="text/css"
                  rel="stylesheet"
                  dangerouslySetInnerHTML={{
                    __html:
                      "\n  \n    #rd-form-joq3m2vy {\n      display: flex;\n      flex-direction: column;\n      align-self: center;\n      max-width: 330px;\n      margin-top: 20px;\n      margin-bottom: 30px;\n    }\n\n    #rd-form-joq3m2vy .bricks-form__fieldset {\n      flex-flow: column nowrap;\n      align-items: flex-start;\n    }\n\n    #rd-form-joq3m2vy .bricks-form__field {\n      margin-bottom: 15px;\n      padding: 0;\n      width: 100.0%;\n    }\n\n    #rd-form-joq3m2vy .bricks-form__field.bricks-form__privacy,\n    #rd-form-joq3m2vy .bricks-form__field.bricks-form__terms {\n        width: 100%;\n    }\n\n    @media screen and (max-width: 768px) {\n      #rd-form-joq3m2vy .bricks-form__field {\n        width: 100%;\n        padding: 0;\n      }\n    }\n\n    #rd-form-joq3m2vy .bricks-form__static {\n      color: #303030;\n      font-family: Open Sans, sans-serif;\n      font-size: 15px;\n      font-style: normal;\n      font-weight: normal;\n    }\n\n    #rd-form-joq3m2vy .bricks-form__static a {\n      color: #303030;\n      text-decoration: underline;\n    }\n\n    #rd-form-joq3m2vy .bricks-form__label {\n      color: #303030;\n      display: inline-block;\n      font-family: Open Sans, sans-serif;\n      font-size: 15px;\n      font-style: normal;\n      font-weight: normal;\n    }\n\n    #rd-form-joq3m2vy label.error {\n      color: #DC3543;\n      font-size: 12px;\n      line-height: 1.1;\n      padding: 2px 0 0 4px;\n    }\n\n    #rd-form-joq3m2vy .bricks-form__label.always-visible,\n    #rd-form-joq3m2vy .bricks-form__field__option .bricks-form__label {\n      display: inline-block;\n    }\n\n    #rd-form-joq3m2vy .bricks-form__input {\n      color: #303030;\n      background-color: #ffffff;\n      border-bottom-style: none;\n      border-left-style: none;\n      border-right-style: none;\n      border-top-style: none;\n      border-color: #a73131;\n      border-radius: 1px;\n      border-width: 0px;\n      font-family: Open Sans, sans-serif;\n      font-size: 18px;\n      \n    }\n\n    #rd-form-joq3m2vy .bricks-form__input::placeholder {\n      color: transparent;\n    }\n\n    #rd-form-joq3m2vy .bricks-form__input.select2-container {\n      padding: 0 !important;\n    }\n\n    #rd-form-joq3m2vy .select2-container .select2-choice {\n      height: 32px !important;\n      line-height: 32px !important;\n\n      color: #303030 !important;\n      font-family: Open Sans, sans-serif !important;\n      font-size: 18px !important;\n      background: #ffffff;\n    }\n\n    #rd-form-joq3m2vy .select2-container .select2-choice .select2-arrow b {\n      background-position: 0 5px !important;\n    }\n\n    #rd-form-joq3m2vy .select2-container .select2-choice .select2-arrow {\n      background: none;\n      border: none;\n    }\n\n    #rd-form-joq3m2vy .bricks-form__input:not(textarea) {\n      height: 32px;\n    }\n\n    #rd-form-joq3m2vy .bricks-form__submit {\n      display: flex;\n      flex-direction: column;\n    }\n\n    #rd-form-joq3m2vy .with-select-flags > .phone-input-group > .select2-container > .select2-choice {\n      border-top-right-radius: 0 !important;\n      border-bottom-right-radius: 0 !important;\n      border-style: none;\n    }\n    #rd-form-joq3m2vy .with-select-flags > .phone-input-group > .select2-container > .select2-choice > .select2-chosen {\n      margin-right: 0px;\n    }\n\n    #rd-form-joq3m2vy .with-select-flags > .phone-input-group > .select2-container > .select2-choice > .select2-chosen > .flag {\n      vertical-align: middle;\n    }\n\n    #rd-form-joq3m2vy .with-select-flags > .phone-input-group > .phone {\n      width: calc(100% - 55px);\n      display: inline-block;\n      border-top-left-radius: 0px !important;\n      border-bottom-left-radius: 0px !important;\n    }\n\n    #rd-form-joq3m2vy .with-select-flags > .phone-country {\n      display: inline-block;\n    }\n\n    #rd-form-joq3m2vy .with-select-flags > .phone-input-group {\n      display: flex;\n    }\n\n    #rd-form-joq3m2vy .with-select-flags > .phone-input-group > .phone-country {\n      width: 55px;\n      display: inline-block;\n    }\n  \n"
                  }}
                />
                <div
                  id="rd-form-joq3m2vy"
                  className="bricks--component bricks-form rd-form"
                >
                  <form
                    id="conversion-form"
                    noValidate="novalidate"
                    action="https://event-api.rdstation.com.br/v2/conversions"
                    data-typed-fields={1}
                    data-lang="pt-BR"
                    data-asset-action="aHR0cHM6Ly92Yy5wYXJjZWlyb3NiYXJpLmNvbS5ici9jb21wcmEtZGUtY2Fy
  dGVpcmEtYWdyYWRlY2ltZW50bw==
  "
                  >
                    <input
                      type="hidden"
                      name="token_rdstation"
                      defaultValue="027470da587d8d328162fd9209b8f054"
                    />
                    <input
                      type="hidden"
                      name="conversion_identifier"
                      defaultValue="vendadecarteira"
                    />
                    <input
                      type="hidden"
                      name="internal_source"
                      defaultValue={2}
                    />
                    <input
                      type="hidden"
                      name="_rd_experiment_content_id"
                      defaultValue=""
                    />
                    <input type="hidden" name="c_utmz" defaultValue="" />
                    <input type="hidden" name="traffic_source" defaultValue="" />
                    <input
                      type="hidden"
                      name="privacy_data[browser]"
                      id="privacy_data_browser"
                    />
                    <div
                      className="bricks-form__fieldset"
                      data-progressive-profiling=""
                    >
                      <div className="bricks-form__field">
                        <label
                          htmlFor="rd-text_field-klmbbqyt"
                          className="bricks-form__label"
                        >
                          Nome*
                        </label>
                        <input
                          id="rd-text_field-klmbbqyt"
                          className="bricks-form__input required js-text js-field-name"
                          name="name"
                          type="text"
                          data-use-type="STRING"
                          placeholder="Nome *"
                          required="required"
                        />
                      </div>
                      <div className="bricks-form__field">
                        <label
                          htmlFor="rd-email_field-klmbbqyu"
                          className="bricks-form__label"
                        >
                          Email*
                        </label>
                        <input
                          id="rd-email_field-klmbbqyu"
                          className="bricks-form__input required js-email js-field-email"
                          name="email"
                          type="email"
                          data-use-type="STRING"
                          placeholder="Email *"
                          required="required"
                        />
                      </div>
                      <div className="bricks-form__field">
                        <label
                          htmlFor="rd-text_field-klmbbqyv"
                          className="bricks-form__label"
                        >
                          Empresa*
                        </label>
                        <input
                          id="rd-text_field-klmbbqyv"
                          className="bricks-form__input required js-text js-field-company"
                          name="company"
                          type="text"
                          data-use-type=""
                          placeholder="Empresa *"
                          required="required"
                        />
                      </div>
                      <div className="bricks-form__field with-select-flags">
                        <label
                          htmlFor="rd-phone_field-klmbbqyw"
                          className="bricks-form__label"
                        >
                          Celular*
                        </label>
                        <div className="phone-input-group">
                          <div
                            className="form-control phone-country"
                            data-type="countries"
                          />
                          <div className="country-field" value="BR" />
                          <input
                            id="rd-phone_field-klmbbqyw"
                            className="bricks-form__input required phone js-phone js-field-mobile_phone"
                            name="mobile_phone"
                            data-input-mask="INTERNATIONAL_MASK"
                            data-use-type="STRING"
                            type="tel"
                            placeholder="Celular *"
                            required="required"
                          />
                        </div>
                      </div>
                      <div className="bricks-form__field">
                        <label htmlFor="captcha" className="bricks-form__label">
                          <span id="math_expression">1 + 1 = ?</span>
                        </label>
                        <input
                          id="captcha"
                          className="bricks-form__input math rd-bricks-captcha"
                          name="captcha"
                          type="text"
                          placeholder="1 + 1 = ?"
                        />
                      </div>
                    </div>
                    <style
                      type="text/css"
                      rel="stylesheet"
                      dangerouslySetInnerHTML={{
                        __html:
                          "\n  \n    a#rd-button-joq3m2w0 {\n      display: flex;\n      flex-direction: column;\n    }\n\n    #rd-button-joq3m2w0 {\n      -ms-flex-align: center;\n      -ms-flex-direction: column;\n      -ms-flex-pack: center;\n      align-self: center;\n      background-color: #0090ff;\n      border-bottom-style: none;\n      border-color: transparent;\n      border-left-style: none;\n      border-radius: 27px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 0px;\n      color: #FFFFFF;\n      cursor: pointer;\n      font-family: Arial, Helvetica, sans-serif;\n      font-size: 18px;\n      font-style: normal;\n      font-weight: bold;\n      height: 55px;\n      justify-content: center;\n      line-height: 1.42857;\n      margin-bottom: 20px;\n      margin-top: 10px;\n      max-width: 245px;\n      text-align: center;\n      text-decoration: none;\n      width: 100%;\n      padding-right: 10px;\n      padding-left: 10px;\n    }\n    @media screen and (max-width: 767px) {\n      #rd-button-joq3m2w0 {\n        height: auto;\n        padding-top: 0.66em;\n        padding-bottom: 0.66em;\n      }\n    }\n  \n"
                      }}
                    />
                    <div className="bricks-form__submit">
                      <button
                        className="bricks--component bricks--component-button rd-button"
                        id="rd-button-joq3m2w0"
                      >
                        QUERO CONVERSAR
                      </button>
                    </div>
                    <div style={{ position: "fixed", left: "-5000px" }}>
                      <input
                        type="text"
                        name="emP7yF13ld"
                        readOnly=""
                        autoComplete="false"
                        tabIndex={-1}
                        defaultValue=""
                      />
                      <input
                        type="text"
                        name="sh0uldN07ch4ng3"
                        readOnly=""
                        autoComplete="false"
                        tabIndex={-1}
                        defaultValue="should_not_change"
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div> */}
            </div>
          </section>
          <style
            type="text/css"
            rel="stylesheet"
            dangerouslySetInnerHTML={{
              __html:
                "\n  \n    #rd-section-jsc68n45 {\n      \n          background-color: #ffffff;\n        \n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n    }\n\n    #rd-section-jsc68n45 > div:not(.bricks--row) {\n      min-height: 0px;\n    }\n  \n",
            }}
          />
          <section
            id="rd-section-jsc68n45"
            className="bricks--section rd-section"
          >
            <style
              type="text/css"
              rel="stylesheet"
              dangerouslySetInnerHTML={{
                __html:
                  "\n  \n    #rd-row-jsc68n46 {\n      min-height: 50px;\n    }\n\n    #rd-row-jsc68n46 .bricks--column > div {\n      min-height: 50px;\n    }\n\n    @media screen and (max-width: 767px) {\n      #rd-row-jsc68n46.bricks--row.rd-row {\n        min-height: auto;\n      }\n    }\n  \n",
              }}
            />
            <div id="rd-row-jsc68n46" className="bricks--row rd-row">
              <style
                type="text/css"
                rel="stylesheet"
                dangerouslySetInnerHTML={{
                  __html:
                    "\n  \n    #rd-column-jsc68n47 {\n      flex: 12 0 0;\n    }\n\n    #rd-column-jsc68n47 > div {\n      \n          background-color: transparent;\n        \n      justify-content: center;\n      padding-top: 0px;\n      padding-right: 30px;\n      padding-bottom: 0px;\n      padding-left: 30px;\n    }\n    @media screen and (max-width: 767px) {\n      #rd-column-jsc68n47 > div {\n        min-height: auto !important;\n      }\n    }\n  \n",
                }}
              />
              <div id="rd-column-jsc68n47" className="bricks--column rd-column">
                <div>
                  <style
                    type="text/css"
                    rel="stylesheet"
                    dangerouslySetInnerHTML={{
                      __html:
                        "\n  \n    #rd-text-jsc6ek2d {\n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n      min-height: auto0px;\n      max-width: 940px;\n      margin-top: 30px;\n      margin-bottom: 20px;\n      align-self: center;\n      width: 100%;\n      word-break: break-word;\n    }\n  \n",
                    }}
                  />
                  <div
                    id="rd-text-jsc6ek2d"
                    className="bricks--component bricks--component-text rd-text"
                  >
                    <h1 style={{ textAlign: "center", lineHeight: 1 }}>
                      Saiba tudo sobre{" "}
                      <span style={{ color: "rgb(0, 144, 255)" }}>venda </span>
                      de sua{" "}
                      <span style={{ color: "rgb(0, 144, 255)" }}>
                        carteira imobiliária
                      </span>
                      <span style={{ color: "rgb(42, 69, 90)" }}>.</span>
                    </h1>
                  </div>
                </div>
              </div>
            </div>
            <style
              type="text/css"
              rel="stylesheet"
              dangerouslySetInnerHTML={{
                __html:
                  "\n  \n    #rd-row-jsc935qk {\n      min-height: 391px;\n    }\n\n    #rd-row-jsc935qk .bricks--column > div {\n      min-height: 391px;\n    }\n\n    @media screen and (max-width: 767px) {\n      #rd-row-jsc935qk.bricks--row.rd-row {\n        min-height: auto;\n      }\n    }\n  \n",
              }}
            />
            <div id="rd-row-jsc935qk" className="bricks--row rd-row">
              <style
                type="text/css"
                rel="stylesheet"
                dangerouslySetInnerHTML={{
                  __html:
                    "\n  \n    #rd-column-jsc935qq {\n      flex: 12 0 0;\n    }\n\n    #rd-column-jsc935qq > div {\n      \n          background-color: transparent;\n        \n      justify-content: center;\n      padding-top: 0px;\n      padding-right: 10px;\n      padding-bottom: 0px;\n      padding-left: 10px;\n    }\n    @media screen and (max-width: 767px) {\n      #rd-column-jsc935qq > div {\n        min-height: auto !important;\n      }\n    }\n  \n",
                }}
              />
              <div id="rd-column-jsc935qq" className="bricks--column rd-column">
                <div>
                  <style
                    type="text/css"
                    rel="stylesheet"
                    dangerouslySetInnerHTML={{
                      __html:
                        "\n  \n    #rd-video-km1xh7t1 {\n      margin-top: 10px;\n      margin-bottom: 20px;\n      align-self: center;\n      width: 600px;\n      max-width: 100%;\n    }\n\n    #rd-video-km1xh7t1 iframe {\n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n    }\n  \n",
                    }}
                  />
                  <div
                    id="rd-video-km1xh7t1"
                    className="bricks--component bricks--component-video rd-video"
                  >
                    <div>
                      <iframe
                        src="https://www.youtube.com/embed/_zz7HE8l37o?&rel=0&autoplay=0&mute=0"
                        frameBorder={0}
                        allow="autoplay; accelerometer; encrypted-media; gyroscope; fullscreen; picture-in-picture"
                        allowFullScreen=""
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <style
            type="text/css"
            rel="stylesheet"
            dangerouslySetInnerHTML={{
              __html:
                "\n  \n    #rd-section-jsdbuq3w {\n      \n          background-color: #0090ff;\n        \n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n    }\n\n    #rd-section-jsdbuq3w > div:not(.bricks--row) {\n      min-height: 0px;\n    }\n  \n",
            }}
          />
          <section
            id="rd-section-jsdbuq3w"
            className="bricks--section rd-section"
          >
            <style
              type="text/css"
              rel="stylesheet"
              dangerouslySetInnerHTML={{
                __html:
                  "\n  \n    #rd-row-jsdbuq3x {\n      min-height: 108px;\n    }\n\n    #rd-row-jsdbuq3x .bricks--column > div {\n      min-height: 108px;\n    }\n\n    @media screen and (max-width: 767px) {\n      #rd-row-jsdbuq3x.bricks--row.rd-row {\n        min-height: auto;\n      }\n    }\n  \n",
              }}
            />
            <div id="rd-row-jsdbuq3x" className="bricks--row rd-row">
              <style
                type="text/css"
                rel="stylesheet"
                dangerouslySetInnerHTML={{
                  __html:
                    "\n  \n    #rd-column-klmeidwc {\n      flex: 12 0 0;\n    }\n\n    #rd-column-klmeidwc > div {\n      \n          background-color: transparent;\n        \n      justify-content: center;\n      padding-top: 0px;\n      padding-right: 30px;\n      padding-bottom: 0px;\n      padding-left: 30px;\n    }\n    @media screen and (max-width: 767px) {\n      #rd-column-klmeidwc > div {\n        min-height: auto !important;\n      }\n    }\n  \n",
                }}
              />
              <div id="rd-column-klmeidwc" className="bricks--column rd-column">
                <div>
                  <style
                    type="text/css"
                    rel="stylesheet"
                    dangerouslySetInnerHTML={{
                      __html:
                        "\n  \n    #rd-text-klmepdqs {\n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n      min-height: auto-57px;\n      max-width: 936px;\n      margin-top: 10px;\n      margin-bottom: 20px;\n      align-self: flex-end;\n      width: 100%;\n      word-break: break-word;\n    }\n  \n",
                    }}
                  />
                  <div
                    id="rd-text-klmepdqs"
                    className="bricks--component bricks--component-text rd-text"
                  >
                    <p style={{ textAlign: "center" }}>
                      <strong
                        style={{
                          color: "rgb(255, 255, 255)",
                          fontSize: 30,
                          fontFamily: "Arial, Helvetica, sans-serif",
                        }}
                      >
                        Tecnisa vende carteira de R$ 86 milhões para o Banco
                        Bari
                      </strong>
                    </p>
                    <p>
                      <br />
                    </p>
                    <p style={{ textAlign: "left" }}>
                      <span
                        style={{
                          fontSize: 18,
                          backgroundColor: "transparent",
                          color: "rgb(255, 255, 255)",
                          fontFamily: "Arial, Helvetica, sans-serif",
                        }}
                      >
                        "O Banco Bari, especializado em crédito com garantia,
                        fechou contrato de compra de carteira da incorporadora
                        Tecnisa no valor de R$ 86 milhões, incluindo 452
                        contratos de empreendimentos comerciais e residenciais
                        localizados nas cidades de São Paulo e Brasília."
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <style
            type="text/css"
            rel="stylesheet"
            dangerouslySetInnerHTML={{
              __html:
                "\n  \n    #rd-section-klme8i3q {\n      \n          background-color: transparent;\n        \n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n    }\n\n    #rd-section-klme8i3q > div:not(.bricks--row) {\n      min-height: 0px;\n    }\n  \n",
            }}
          />
          <section
            id="rd-section-klme8i3q"
            className="bricks--section rd-section"
          >
            <style
              type="text/css"
              rel="stylesheet"
              dangerouslySetInnerHTML={{
                __html:
                  "\n  \n    #rd-row-klme8i3r {\n      min-height: 50px;\n    }\n\n    #rd-row-klme8i3r .bricks--column > div {\n      min-height: 50px;\n    }\n\n    @media screen and (max-width: 767px) {\n      #rd-row-klme8i3r.bricks--row.rd-row {\n        min-height: auto;\n      }\n    }\n  \n",
              }}
            />
            <div id="rd-row-klme8i3r" className="bricks--row rd-row">
              <style
                type="text/css"
                rel="stylesheet"
                dangerouslySetInnerHTML={{
                  __html:
                    "\n  \n    #rd-column-klme8i3s {\n      flex: 12 0 0;\n    }\n\n    #rd-column-klme8i3s > div {\n      \n          background-color: transparent;\n        \n      justify-content: center;\n      padding-top: 0px;\n      padding-right: 30px;\n      padding-bottom: 0px;\n      padding-left: 30px;\n    }\n    @media screen and (max-width: 767px) {\n      #rd-column-klme8i3s > div {\n        min-height: auto !important;\n      }\n    }\n  \n",
                }}
              />
              <div id="rd-column-klme8i3s" className="bricks--column rd-column">
                <div>
                  <style
                    type="text/css"
                    rel="stylesheet"
                    dangerouslySetInnerHTML={{
                      __html:
                        "\n  \n    #rd-text-klmf6zdg {\n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n      min-height: auto0px;\n      max-width: 905px;\n      margin-top: 10px;\n      margin-bottom: 20px;\n      align-self: center;\n      width: 100%;\n      word-break: break-word;\n    }\n  \n",
                    }}
                  />
                  <div
                    id="rd-text-klmf6zdg"
                    className="bricks--component bricks--component-text rd-text"
                  >
                    <h1 style={{ textAlign: "center", lineHeight: 1 }}>
                      <strong
                        style={{
                          fontFamily: "Arial, Helvetica, sans-serif",
                          fontSize: 30,
                        }}
                      >
                        Quais são as vantagens da venda de recebíveis
                        imobiliários?
                      </strong>
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <style
            type="text/css"
            rel="stylesheet"
            dangerouslySetInnerHTML={{
              __html:
                "\n  \n    #rd-section-kqmslkre {\n      \n          background-color: transparent;\n        \n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n    }\n\n    #rd-section-kqmslkre > div:not(.bricks--row) {\n      min-height: 0px;\n    }\n  \n",
            }}
          />
          <section
            id="rd-section-kqmslkre"
            className="bricks--section rd-section"
          >
            <style
              type="text/css"
              rel="stylesheet"
              dangerouslySetInnerHTML={{
                __html:
                  "\n  \n    #rd-row-kqmslkrf {\n      min-height: 50px;\n    }\n\n    #rd-row-kqmslkrf .bricks--column > div {\n      min-height: 50px;\n    }\n\n    @media screen and (max-width: 767px) {\n      #rd-row-kqmslkrf.bricks--row.rd-row {\n        min-height: auto;\n      }\n    }\n  \n",
              }}
            />
            <div id="rd-row-kqmslkrf" className="bricks--row rd-row">
              <style
                type="text/css"
                rel="stylesheet"
                dangerouslySetInnerHTML={{
                  __html:
                    "\n  \n    #rd-column-kqmslkrg {\n      flex: 1 0 0;\n    }\n\n    #rd-column-kqmslkrg > div {\n      \n          background-color: transparent;\n        \n      justify-content: center;\n      padding-top: 0px;\n      padding-right: 10px;\n      padding-bottom: 0px;\n      padding-left: 10px;\n    }\n    @media screen and (max-width: 767px) {\n      #rd-column-kqmslkrg > div {\n        min-height: auto !important;\n      }\n    }\n  \n",
                }}
              />
              <div id="rd-column-kqmslkrg" className="bricks--column rd-column">
                <div>
                  <style
                    type="text/css"
                    rel="stylesheet"
                    dangerouslySetInnerHTML={{
                      __html:
                        "\n  \n    #rd-image-kqmslwp4 {\n      margin-top: 10px;\n      margin-bottom: 20px;\n      align-self: flex-start;\n      max-width: 57px;\n    }\n\n    #rd-image-kqmslwp4 a,\n    #rd-image-kqmslwp4 img {\n      width: 57px;\n      max-width: 100%;\n      height: auto;\n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n    }\n    @media screen and (max-width: 767px) {\n      #rd-image-kqmslwp4 {\n        align-self: center;\n      }\n    }\n  \n",
                    }}
                  />
                  <div
                    id="rd-image-kqmslwp4"
                    className="bricks--component bricks--component-image rd-image"
                  >
                    <img
                      src="https://d335luupugsy2.cloudfront.net/cms/files/13591/1625256133/$aozqto5em2h"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <style
                type="text/css"
                rel="stylesheet"
                dangerouslySetInnerHTML={{
                  __html:
                    "\n  \n    #rd-column-kqmslski {\n      flex: 11 0 0;\n    }\n\n    #rd-column-kqmslski > div {\n      \n          background-color: transparent;\n        \n      justify-content: center;\n      padding-top: 0px;\n      padding-right: 30px;\n      padding-bottom: 0px;\n      padding-left: 30px;\n    }\n    @media screen and (max-width: 767px) {\n      #rd-column-kqmslski > div {\n        min-height: auto !important;\n      }\n    }\n  \n",
                }}
              />
              <div id="rd-column-kqmslski" className="bricks--column rd-column">
                <div>
                  <style
                    type="text/css"
                    rel="stylesheet"
                    dangerouslySetInnerHTML={{
                      __html:
                        "\n  \n    #rd-text-kqmsm0zs {\n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n      min-height: auto0px;\n      max-width: 824px;\n      margin-top: 10px;\n      margin-bottom: 20px;\n      align-self: center;\n      width: 100%;\n      word-break: break-word;\n    }\n  \n",
                    }}
                  />
                  <div
                    id="rd-text-kqmsm0zs"
                    className="bricks--component bricks--component-text rd-text"
                  >
                    <p style={{ textAlign: "left" }}>
                      <span
                        style={{
                          fontSize: 18,
                          fontFamily: "Arial, Helvetica, sans-serif",
                        }}
                      >
                        Efetuamos a compra de sua carteira imobiliária em até 30
                        dias corridos. Isso mesmo, você recebe seu dinheiro em
                        um mês.
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <style
            type="text/css"
            rel="stylesheet"
            dangerouslySetInnerHTML={{
              __html:
                "\n  \n    #rd-section-kqmsn82r {\n      \n          background-color: transparent;\n        \n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n    }\n\n    #rd-section-kqmsn82r > div:not(.bricks--row) {\n      min-height: 0px;\n    }\n  \n",
            }}
          />
          <section
            id="rd-section-kqmsn82r"
            className="bricks--section rd-section"
          >
            <style
              type="text/css"
              rel="stylesheet"
              dangerouslySetInnerHTML={{
                __html:
                  "\n  \n    #rd-row-kqmsn82s {\n      min-height: 50px;\n    }\n\n    #rd-row-kqmsn82s .bricks--column > div {\n      min-height: 50px;\n    }\n\n    @media screen and (max-width: 767px) {\n      #rd-row-kqmsn82s.bricks--row.rd-row {\n        min-height: auto;\n      }\n    }\n  \n",
              }}
            />
            <div id="rd-row-kqmsn82s" className="bricks--row rd-row">
              <style
                type="text/css"
                rel="stylesheet"
                dangerouslySetInnerHTML={{
                  __html:
                    "\n  \n    #rd-column-kqmsnb4i {\n      flex: 1 0 0;\n    }\n\n    #rd-column-kqmsnb4i > div {\n      \n          background-color: transparent;\n        \n      justify-content: center;\n      padding-top: 0px;\n      padding-right: 10px;\n      padding-bottom: 0px;\n      padding-left: 10px;\n    }\n    @media screen and (max-width: 767px) {\n      #rd-column-kqmsnb4i > div {\n        min-height: auto !important;\n      }\n    }\n  \n",
                }}
              />
              <div id="rd-column-kqmsnb4i" className="bricks--column rd-column">
                <div>
                  <style
                    type="text/css"
                    rel="stylesheet"
                    dangerouslySetInnerHTML={{
                      __html:
                        "\n  \n    #rd-image-kqmsrr0g {\n      margin-top: 10px;\n      margin-bottom: 20px;\n      align-self: center;\n      max-width: 57px;\n    }\n\n    #rd-image-kqmsrr0g a,\n    #rd-image-kqmsrr0g img {\n      width: 57px;\n      max-width: 100%;\n      height: auto;\n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n    }\n    @media screen and (max-width: 767px) {\n      #rd-image-kqmsrr0g {\n        align-self: center;\n      }\n    }\n  \n",
                    }}
                  />
                  <div
                    id="rd-image-kqmsrr0g"
                    className="bricks--component bricks--component-image rd-image"
                  >
                    <img
                      src="https://d335luupugsy2.cloudfront.net/cms/files/13591/1625256133/$clxisj5zp7g"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <style
                type="text/css"
                rel="stylesheet"
                dangerouslySetInnerHTML={{
                  __html:
                    "\n  \n    #rd-column-kqmsn82t {\n      flex: 11 0 0;\n    }\n\n    #rd-column-kqmsn82t > div {\n      \n          background-color: transparent;\n        \n      justify-content: center;\n      padding-top: 0px;\n      padding-right: 30px;\n      padding-bottom: 0px;\n      padding-left: 30px;\n    }\n    @media screen and (max-width: 767px) {\n      #rd-column-kqmsn82t > div {\n        min-height: auto !important;\n      }\n    }\n  \n",
                }}
              />
              <div id="rd-column-kqmsn82t" className="bricks--column rd-column">
                <div>
                  <style
                    type="text/css"
                    rel="stylesheet"
                    dangerouslySetInnerHTML={{
                      __html:
                        "\n  \n    #rd-text-kqmsnh8q {\n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n      min-height: auto25px;\n      max-width: 823px;\n      margin-top: 10px;\n      margin-bottom: 20px;\n      align-self: center;\n      width: 100%;\n      word-break: break-word;\n    }\n  \n",
                    }}
                  />
                  <div
                    id="rd-text-kqmsnh8q"
                    className="bricks--component bricks--component-text rd-text"
                  >
                    <p style={{ textAlign: "left" }}>
                      <span
                        style={{
                          fontSize: 18,
                          fontFamily: "Arial, Helvetica, sans-serif",
                        }}
                      >
                        Mas não precisa esperar um mês para receber o pagamento.
                        Pagamos 70% na assinatura de contrato.
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <style
            type="text/css"
            rel="stylesheet"
            dangerouslySetInnerHTML={{
              __html:
                "\n  \n    #rd-section-klmfaied {\n      \n          background-color: transparent;\n        \n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n    }\n\n    #rd-section-klmfaied > div:not(.bricks--row) {\n      min-height: 0px;\n    }\n  \n",
            }}
          />
          <section
            id="rd-section-klmfaied"
            className="bricks--section rd-section"
          >
            <style
              type="text/css"
              rel="stylesheet"
              dangerouslySetInnerHTML={{
                __html:
                  "\n  \n    #rd-row-klmfaiee {\n      min-height: 50px;\n    }\n\n    #rd-row-klmfaiee .bricks--column > div {\n      min-height: 50px;\n    }\n\n    @media screen and (max-width: 767px) {\n      #rd-row-klmfaiee.bricks--row.rd-row {\n        min-height: auto;\n      }\n    }\n  \n",
              }}
            />
            <div id="rd-row-klmfaiee" className="bricks--row rd-row">
              <style
                type="text/css"
                rel="stylesheet"
                dangerouslySetInnerHTML={{
                  __html:
                    "\n  \n    #rd-column-kqmsqm8q {\n      flex: 1 0 0;\n    }\n\n    #rd-column-kqmsqm8q > div {\n      \n          background-color: transparent;\n        \n      justify-content: center;\n      padding-top: 0px;\n      padding-right: 10px;\n      padding-bottom: 0px;\n      padding-left: 10px;\n    }\n    @media screen and (max-width: 767px) {\n      #rd-column-kqmsqm8q > div {\n        min-height: auto !important;\n      }\n    }\n  \n",
                }}
              />
              <div id="rd-column-kqmsqm8q" className="bricks--column rd-column">
                <div>
                  <style
                    type="text/css"
                    rel="stylesheet"
                    dangerouslySetInnerHTML={{
                      __html:
                        "\n  \n    #rd-image-kqmsrtpd {\n      margin-top: 10px;\n      margin-bottom: 20px;\n      align-self: center;\n      max-width: 57px;\n    }\n\n    #rd-image-kqmsrtpd a,\n    #rd-image-kqmsrtpd img {\n      width: 57px;\n      max-width: 100%;\n      height: auto;\n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n    }\n    @media screen and (max-width: 767px) {\n      #rd-image-kqmsrtpd {\n        align-self: center;\n      }\n    }\n  \n",
                    }}
                  />
                  <div
                    id="rd-image-kqmsrtpd"
                    className="bricks--component bricks--component-image rd-image"
                  >
                    <img
                      src="https://d335luupugsy2.cloudfront.net/cms/files/13591/1625256133/$f3zyxe604c"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <style
                type="text/css"
                rel="stylesheet"
                dangerouslySetInnerHTML={{
                  __html:
                    "\n  \n    #rd-column-klmfaief {\n      flex: 11 0 0;\n    }\n\n    #rd-column-klmfaief > div {\n      \n          background-color: transparent;\n        \n      justify-content: center;\n      padding-top: 0px;\n      padding-right: 30px;\n      padding-bottom: 0px;\n      padding-left: 30px;\n    }\n    @media screen and (max-width: 767px) {\n      #rd-column-klmfaief > div {\n        min-height: auto !important;\n      }\n    }\n  \n",
                }}
              />
              <div id="rd-column-klmfaief" className="bricks--column rd-column">
                <div>
                  <style
                    type="text/css"
                    rel="stylesheet"
                    dangerouslySetInnerHTML={{
                      __html:
                        "\n  \n    #rd-text-klmfbku4 {\n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n      min-height: auto0px;\n      max-width: 940px;\n      margin-top: 10px;\n      margin-bottom: 20px;\n      align-self: center;\n      width: 100%;\n      word-break: break-word;\n    }\n  \n",
                    }}
                  />
                  <div
                    id="rd-text-klmfbku4"
                    className="bricks--component bricks--component-text rd-text"
                  >
                    <p style={{ textAlign: "justify" }}>
                      <span
                        style={{
                          fontSize: 18,
                          fontFamily: "Arial, Helvetica, sans-serif",
                        }}
                      >
                        Não cobramos taxa de estruturação.
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <style
            type="text/css"
            rel="stylesheet"
            dangerouslySetInnerHTML={{
              __html:
                "\n  \n    #rd-section-klmg6hzx {\n      \n          background-color: rgba(0,0,0,1);\n        \n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n    }\n\n    #rd-section-klmg6hzx > div:not(.bricks--row) {\n      min-height: 0px;\n    }\n  \n",
            }}
          />
          <section
            id="rd-section-klmg6hzx"
            className="bricks--section rd-section"
          >
            <style
              type="text/css"
              rel="stylesheet"
              dangerouslySetInnerHTML={{
                __html:
                  "\n  \n    #rd-row-klmg6hzy {\n      min-height: 50px;\n    }\n\n    #rd-row-klmg6hzy .bricks--column > div {\n      min-height: 50px;\n    }\n\n    @media screen and (max-width: 767px) {\n      #rd-row-klmg6hzy.bricks--row.rd-row {\n        min-height: auto;\n      }\n    }\n  \n",
              }}
            />
            <div id="rd-row-klmg6hzy" className="bricks--row rd-row">
              <style
                type="text/css"
                rel="stylesheet"
                dangerouslySetInnerHTML={{
                  __html:
                    "\n  \n    #rd-column-klmg6hzz {\n      flex: 12 0 0;\n    }\n\n    #rd-column-klmg6hzz > div {\n      \n          background-color: rgba(0,0,0,1);\n        \n      justify-content: center;\n      padding-top: 0px;\n      padding-right: 30px;\n      padding-bottom: 0px;\n      padding-left: 30px;\n    }\n    @media screen and (max-width: 767px) {\n      #rd-column-klmg6hzz > div {\n        min-height: auto !important;\n      }\n    }\n  \n",
                }}
              />
              <div id="rd-column-klmg6hzz" className="bricks--column rd-column">
                <div>
                  <style
                    type="text/css"
                    rel="stylesheet"
                    dangerouslySetInnerHTML={{
                      __html:
                        "\n  \n    #rd-text-kqmqinin {\n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n      min-height: auto-42px;\n      max-width: 386px;\n      margin-top: 20px;\n      margin-bottom: 10px;\n      align-self: center;\n      width: 100%;\n      word-break: break-word;\n    }\n  \n",
                    }}
                  />
                  <div
                    id="rd-text-kqmqinin"
                    className="bricks--component bricks--component-text rd-text"
                  >
                    <p style={{ textAlign: "center" }}>
                      <strong
                        style={{ color: "rgb(255, 255, 255)", fontSize: 30 }}
                      >
                        Quem é o Banco Bari?
                      </strong>
                    </p>
                  </div>
                  <style
                    type="text/css"
                    rel="stylesheet"
                    dangerouslySetInnerHTML={{
                      __html:
                        "\n  \n    #rd-text-kqmqjuxi {\n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n      min-height: auto-77px;\n      max-width: 936px;\n      margin-top: 10px;\n      margin-bottom: 20px;\n      align-self: center;\n      width: 100%;\n      word-break: break-word;\n    }\n  \n",
                    }}
                  />
                  <div
                    id="rd-text-kqmqjuxi"
                    className="bricks--component bricks--component-text rd-text"
                  >
                    <p style={{ textAlign: "justify" }}>
                      <span
                        style={{ fontSize: 18, color: "rgb(255, 255, 255)" }}
                      >
                        Quer saber mais sobre o Banco Bari? Somos um banco
                        digital especializado em originação, concessão e
                        securitização de crédito imobiliário, com mais de 25
                        anos de experiência no mercado financeiro.
                      </span>
                    </p>
                    <p style={{ textAlign: "justify" }}>
                      <br />
                    </p>
                    <p style={{ textAlign: "justify" }}>
                      <span
                        style={{ fontSize: 18, color: "rgb(255, 255, 255)" }}
                      >
                        Nosso objetivo é que cada brasileiro tenha a vida
                        financeira que sempre sonhou. Para isso, investimos em
                        tecnologia e inovação para criar soluções em crédito e
                        produtos bancários inteligentes, seguros, justos e
                        acessíveis.{" "}
                      </span>
                    </p>
                    <p style={{ textAlign: "justify" }}>
                      <br />
                    </p>
                    <p style={{ textAlign: "justify" }}>
                      <span
                        style={{ fontSize: 18, color: "rgb(255, 255, 255)" }}
                      >
                        Saiba mais sobre o Banco Bari:{" "}
                      </span>
                      <a
                        href="https://bancobari.com.br/banco"
                        rel="noopener noreferrer"
                        target="_blank"
                        title="Banco Bari"
                        style={{ fontSize: 18, color: "rgb(0, 144, 255)" }}
                      >
                        bancobari.com.br/banco
                      </a>
                    </p>
                  </div>
                  <style
                    type="text/css"
                    rel="stylesheet"
                    dangerouslySetInnerHTML={{
                      __html:
                        "\n  \n    #rd-video-kqmql77v {\n      margin-top: 10px;\n      margin-bottom: 20px;\n      align-self: center;\n      width: 500px;\n      max-width: 100%;\n    }\n\n    #rd-video-kqmql77v iframe {\n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n    }\n  \n",
                    }}
                  />
                  <div
                    id="rd-video-kqmql77v"
                    className="bricks--component bricks--component-video rd-video"
                  >
                    <div>
                      <iframe
                        src="https://www.youtube.com/embed/9M1BoSbB48o?&rel=0&autoplay=0&mute=0"
                        frameBorder={0}
                        allow="autoplay; accelerometer; encrypted-media; gyroscope; fullscreen; picture-in-picture"
                        allowFullScreen=""
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <style
            type="text/css"
            rel="stylesheet"
            dangerouslySetInnerHTML={{
              __html:
                "\n  \n    #rd-section-klmg5llu {\n      \n          background-color: rgba(7,0,0,1);\n        \n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n    }\n\n    #rd-section-klmg5llu > div:not(.bricks--row) {\n      min-height: 0px;\n    }\n  \n",
            }}
          />
          <section
            id="rd-section-klmg5llu"
            className="bricks--section rd-section"
          >
            <style
              type="text/css"
              rel="stylesheet"
              dangerouslySetInnerHTML={{
                __html:
                  "\n  \n    #rd-row-klmgsma8 {\n      min-height: 50px;\n    }\n\n    #rd-row-klmgsma8 .bricks--column > div {\n      min-height: 50px;\n    }\n\n    @media screen and (max-width: 767px) {\n      #rd-row-klmgsma8.bricks--row.rd-row {\n        min-height: auto;\n      }\n    }\n  \n",
              }}
            />
            <div id="rd-row-klmgsma8" className="bricks--row rd-row">
              <style
                type="text/css"
                rel="stylesheet"
                dangerouslySetInnerHTML={{
                  __html:
                    "\n  \n    #rd-column-klmgsu8g {\n      flex: 6 0 0;\n    }\n\n    #rd-column-klmgsu8g > div {\n      \n          background-color: transparent;\n        \n      justify-content: center;\n      padding-top: 0px;\n      padding-right: 30px;\n      padding-bottom: 0px;\n      padding-left: 30px;\n    }\n    @media screen and (max-width: 767px) {\n      #rd-column-klmgsu8g > div {\n        min-height: auto !important;\n      }\n    }\n  \n",
                }}
              />
              <div id="rd-column-klmgsu8g" className="bricks--column rd-column">
                <div>
                  <style
                    type="text/css"
                    rel="stylesheet"
                    dangerouslySetInnerHTML={{
                      __html:
                        "\n  \n    #rd-image-klmgtyxd {\n      margin-top: 10px;\n      margin-bottom: 10px;\n      align-self: flex-start;\n      max-width: 138px;\n    }\n\n    #rd-image-klmgtyxd a,\n    #rd-image-klmgtyxd img {\n      width: 138px;\n      max-width: 100%;\n      height: auto;\n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n    }\n    @media screen and (max-width: 767px) {\n      #rd-image-klmgtyxd {\n        align-self: center;\n      }\n    }\n  \n",
                    }}
                  />
                  <div
                    id="rd-image-klmgtyxd"
                    className="bricks--component bricks--component-image rd-image"
                  >
                    <img
                      src="https://d335luupugsy2.cloudfront.net/cms/files/13591/1614344509/$j2ysprodlu7"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <style
                type="text/css"
                rel="stylesheet"
                dangerouslySetInnerHTML={{
                  __html:
                    "\n  \n    #rd-column-klmgsma9 {\n      flex: 6 0 0;\n    }\n\n    #rd-column-klmgsma9 > div {\n      \n          background-color: transparent;\n        \n      justify-content: center;\n      padding-top: 0px;\n      padding-right: 30px;\n      padding-bottom: 0px;\n      padding-left: 30px;\n    }\n    @media screen and (max-width: 767px) {\n      #rd-column-klmgsma9 > div {\n        min-height: auto !important;\n      }\n    }\n  \n",
                }}
              />
              <div id="rd-column-klmgsma9" className="bricks--column rd-column">
                <div>
                  <style
                    type="text/css"
                    rel="stylesheet"
                    dangerouslySetInnerHTML={{
                      __html:
                        "\n  \n    #rd-text-klmh65v0 {\n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n      min-height: auto25px;\n      max-width: 326px;\n      margin-top: 10px;\n      margin-bottom: 10px;\n      align-self: flex-start;\n      width: 100%;\n      word-break: break-word;\n    }\n  \n",
                    }}
                  />
                  <div
                    id="rd-text-klmh65v0"
                    className="bricks--component bricks--component-text rd-text"
                  >
                    <p>
                      <span
                        style={{
                          color: "rgb(0, 144, 255)",
                          fontSize: 18,
                          fontFamily: "Lato, sans-serif",
                        }}
                      >
                        Quer falar com a gente ou ficou com alguma dúvida?
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <style
              type="text/css"
              rel="stylesheet"
              dangerouslySetInnerHTML={{
                __html:
                  "\n  \n    #rd-row-klmg5llv {\n      min-height: 87px;\n    }\n\n    #rd-row-klmg5llv .bricks--column > div {\n      min-height: 87px;\n    }\n\n    @media screen and (max-width: 767px) {\n      #rd-row-klmg5llv.bricks--row.rd-row {\n        min-height: auto;\n      }\n    }\n  \n",
              }}
            />
            <div id="rd-row-klmg5llv" className="bricks--row rd-row">
              <style
                type="text/css"
                rel="stylesheet"
                dangerouslySetInnerHTML={{
                  __html:
                    "\n  \n    #rd-column-klmg5llw {\n      flex: 6 0 0;\n    }\n\n    #rd-column-klmg5llw > div {\n      \n          background-color: transparent;\n        \n      justify-content: center;\n      padding-top: 0px;\n      padding-right: 30px;\n      padding-bottom: 0px;\n      padding-left: 30px;\n    }\n    @media screen and (max-width: 767px) {\n      #rd-column-klmg5llw > div {\n        min-height: auto !important;\n      }\n    }\n  \n",
                }}
              />
              <div id="rd-column-klmg5llw" className="bricks--column rd-column">
                <div>
                  <style
                    type="text/css"
                    rel="stylesheet"
                    dangerouslySetInnerHTML={{
                      __html:
                        "\n  \n    #rd-text-klmgux09 {\n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n      min-height: auto-50px;\n      max-width: 272px;\n      margin-top: 10px;\n      margin-bottom: 30px;\n      align-self: flex-start;\n      width: 100%;\n      word-break: break-word;\n    }\n  \n",
                    }}
                  />
                  <div
                    id="rd-text-klmgux09"
                    className="bricks--component bricks--component-text rd-text"
                  >
                    <p>
                      <span
                        style={{
                          fontFamily: "Lato, sans-serif",
                          fontSize: 18,
                          color: "rgb(255, 255, 255)",
                        }}
                      >
                        Para saber mais sobre Banco Bari{" "}
                      </span>
                    </p>
                    <p>
                      <span
                        style={{
                          fontFamily: "Lato, sans-serif",
                          fontSize: 18,
                          color: "rgb(255, 255, 255)",
                        }}
                      >
                        e os produtos Bari, acesse:
                      </span>
                    </p>
                    <p>
                      <a
                        href="https://bancobari.com.br/"
                        rel="noopener noreferrer"
                        target="_self"
                        title="Banco Bari"
                        style={{
                          fontFamily: "Lato, sans-serif",
                          color: "rgb(0, 144, 255)",
                          fontSize: 18,
                        }}
                      >
                        bancobari.com.br
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              <style
                type="text/css"
                rel="stylesheet"
                dangerouslySetInnerHTML={{
                  __html:
                    "\n  \n    #rd-column-klmgc2n1 {\n      flex: 6 0 0;\n    }\n\n    #rd-column-klmgc2n1 > div {\n      \n          background-color: transparent;\n        \n      justify-content: center;\n      padding-top: 0px;\n      padding-right: 30px;\n      padding-bottom: 0px;\n      padding-left: 30px;\n    }\n    @media screen and (max-width: 767px) {\n      #rd-column-klmgc2n1 > div {\n        min-height: auto !important;\n      }\n    }\n  \n",
                }}
              />
              <div id="rd-column-klmgc2n1" className="bricks--column rd-column">
                <div>
                  <style
                    type="text/css"
                    rel="stylesheet"
                    dangerouslySetInnerHTML={{
                      __html:
                        "\n  \n    #rd-text-klmh97py {\n      border-bottom-style: none;\n      border-color: #000000;\n      border-left-style: none;\n      border-radius: 0px;\n      border-right-style: none;\n      border-top-style: none;\n      border-width: 1px;\n      min-height: auto-23px;\n      max-width: 350px;\n      margin-top: 10px;\n      margin-bottom: 30px;\n      align-self: flex-start;\n      width: 100%;\n      word-break: break-word;\n    }\n  \n",
                    }}
                  />
                  <div
                    id="rd-text-klmh97py"
                    className="bricks--component bricks--component-text rd-text"
                  >
                    <p>
                      <span
                        style={{
                          fontFamily: "Lato, sans-serif",
                          fontSize: 16,
                          color: "rgb(255, 255, 255)",
                        }}
                      >
                        4007-2888 capitais e regiões metropolitanas
                      </span>
                    </p>
                    <p>
                      <span
                        style={{
                          fontFamily: "Lato, sans-serif",
                          fontSize: 16,
                          color: "rgb(255, 255, 255)",
                        }}
                      >
                        0800-0071777 demais localidades
                      </span>
                    </p>
                    <p>
                      <span
                        style={{
                          fontFamily: "Lato, sans-serif",
                          fontSize: 16,
                          color: "rgb(255, 255, 255)",
                        }}
                      >
                        {" "}
                        (11) 9 9712-0472 WhatsApp
                      </span>
                    </p>
                    <p>
                      <span
                        style={{
                          fontFamily: "Lato, sans-serif",
                          fontSize: 16,
                          color: "rgb(255, 255, 255)",
                        }}
                      >
                        ajuda@bancobari.com.br
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div data-editable="true" data-field-name="landing_page" />
      <style dangerouslySetInnerHTML={{ __html: "\n      \n    " }} />
    </>
  );
}
